import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import SEO from '../../components/SEO/SEO';
import './Legal.css';

function CookiePolicy() {
  const { t } = useTranslation();

  return (
    <div className="legal">
      <SEO
        title="Cookie Policy — Unimar Boats"
        description="Learn how Unimar uses cookies on our website and how you can manage your cookie preferences."
        url="/cookie-policy"
      />
      <Header />

      <div className="legal__hero">
        <div className="legal__hero-overlay" />
        <div className="legal__hero-content">
          <h1 className="legal__hero-title">{t('cookiePolicy.title')}</h1>
          <p className="legal__hero-sub">{t('cookiePolicy.lastUpdated')}</p>
        </div>
      </div>

      <div className="legal__body">
        <div className="legal__inner">

          <section className="legal__section">
            <h2 className="legal__section-title">{t('cookiePolicy.s1.heading')}</h2>
            <p className="legal__text">{t('cookiePolicy.s1.p1')}</p>
            <p className="legal__text">{t('cookiePolicy.s1.p2')}</p>
          </section>

          <section className="legal__section">
            <h2 className="legal__section-title">{t('cookiePolicy.s2.heading')}</h2>
            <p className="legal__text">{t('cookiePolicy.s2.intro')}</p>
            <ul className="legal__list">
              <li>{t('cookiePolicy.s2.item1')}</li>
              <li>{t('cookiePolicy.s2.item2')}</li>
              <li>{t('cookiePolicy.s2.item3')}</li>
              <li>{t('cookiePolicy.s2.item4')}</li>
            </ul>
          </section>

          <section className="legal__section">
            <h2 className="legal__section-title">{t('cookiePolicy.s3.heading')}</h2>

            <div className="legal__cookie-type">
              <h3 className="legal__cookie-name">{t('cookiePolicy.s3.essentialName')}</h3>
              <p className="legal__text">{t('cookiePolicy.s3.essentialP')}</p>
              <p className="legal__text legal__text--meta">{t('cookiePolicy.s3.essentialMeta')}</p>
            </div>

            <div className="legal__cookie-type">
              <h3 className="legal__cookie-name">{t('cookiePolicy.s3.analyticsName')}</h3>
              <p className="legal__text">{t('cookiePolicy.s3.analyticsP')}</p>
              <p className="legal__text legal__text--meta">{t('cookiePolicy.s3.analyticsMeta')}</p>
            </div>

            <div className="legal__cookie-type">
              <h3 className="legal__cookie-name">{t('cookiePolicy.s3.functionalName')}</h3>
              <p className="legal__text">{t('cookiePolicy.s3.functionalP')}</p>
            </div>
          </section>

          <section className="legal__section">
            <h2 className="legal__section-title">{t('cookiePolicy.s4.heading')}</h2>
            <p className="legal__text">{t('cookiePolicy.s4.p')}</p>
            <ul className="legal__list">
              <li>{t('cookiePolicy.s4.item1')}</li>
              <li>{t('cookiePolicy.s4.item2')}</li>
            </ul>
          </section>

          <section className="legal__section">
            <h2 className="legal__section-title">{t('cookiePolicy.s5.heading')}</h2>
            <p className="legal__text">{t('cookiePolicy.s5.p1')}</p>
            <p className="legal__text">
              <strong>{t('cookiePolicy.s5.browserLabel')}</strong> {t('cookiePolicy.s5.browserP')}
            </p>
            <ul className="legal__list">
              <li>{t('cookiePolicy.s5.item1')}</li>
              <li>{t('cookiePolicy.s5.item2')}</li>
              <li>{t('cookiePolicy.s5.item3')}</li>
              <li>{t('cookiePolicy.s5.item4')}</li>
            </ul>
            <p className="legal__text">
              <strong>{t('cookiePolicy.s5.optOutLabel')}</strong> {t('cookiePolicy.s5.optOutP')}{' '}
              <a href="https://tools.google.com/dlpage/gaoptout" className="legal__link" target="_blank" rel="noreferrer">
                {t('cookiePolicy.s5.optOutLink')}
              </a>.
            </p>
          </section>

          <section className="legal__section">
            <h2 className="legal__section-title">{t('cookiePolicy.s6.heading')}</h2>
            <p className="legal__text">{t('cookiePolicy.s6.p')}</p>
          </section>

          <section className="legal__section">
            <h2 className="legal__section-title">{t('cookiePolicy.s7.heading')}</h2>
            <p className="legal__text">
              {t('cookiePolicy.s7.p')}<br />
              Email: <a href="mailto:info@unimar.com" className="legal__link">info@unimar.com</a>
            </p>
          </section>

        </div>
      </div>

      <Footer />
    </div>
  );
}

export default CookiePolicy;
